import { connect } from 'react-redux';
import {
  changeDimensionType,
  changeFirstEvent,
  changeReturnEvent,
} from '../../../../../actions/dashboards/retention';
import RetentionSimplifiedComposeContainer from '../../../../../components/dashboards/cards/builder/retentionSimple/RetentionSimplifiedComposeContainer';
import { getDashboardRetentionSimpleDimensionType } from '../../../../../reducers/analyticsApp';

const mapStateToProps = (state, { unitId }) => ({
  selectedDimensionType: getDashboardRetentionSimpleDimensionType(state, unitId),
});

const mapDispatchToProps = (dispatch, { unitId }) => ({
  onDimensionTypeChange: (dimensionType) => dispatch(changeDimensionType(unitId, dimensionType)),
  onFirstEventChange: (event) => dispatch(changeFirstEvent(unitId, event)),
  onReturnEventChange: (event) => dispatch(changeReturnEvent(unitId, event)),
});

export default connect(mapStateToProps, mapDispatchToProps)(RetentionSimplifiedComposeContainer);
